import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about">
      <div className="about-content">
        <div className="about-text">
          <h2 className="about-heading">Traditional South Indian Cuisine</h2>
          <p className="about-description">
            Experience the authentic flavors of South India with our carefully crafted traditional dishes. 
            Each recipe is prepared using time-honored methods passed down through generations, bringing 
            you the genuine taste of home-cooked South Indian cuisine.
          </p>
          <p className="about-description">
            From our signature curd rice to crispy dosas and fluffy idlys, every dish celebrates the 
            rich culinary heritage of South India. We use traditional spices and authentic cooking 
            techniques to ensure each bite transports you to the heart of South Indian tradition.
          </p>
          <div className="about-pricing">
            <span className="pricing-highlight">All dishes just $5</span>
            <p className="pricing-description">
              Authentic, traditional South Indian food shouldn't be expensive. 
              Enjoy our complete menu at an affordable price.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
